<template>
	<div class="cat_box">
		<!-- <div class="cb_tit">
			<p>联系交控</p>
			<p>contact Jiaokong</p>
		</div> -->
        <div class="cb_address">微信公众号：</div>
		<div class="cb_ma">
			<img :src="staticImg+comInfo.image">
		</div>
		<div class="cb_address mt_30">
			<div>地址：{{comInfo.address}}</div>
			<!-- <div>邮箱：{{comInfo.email}}</div> -->
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			comInfo: {},
			staticImg: this.$staticImg,
		};
	},
	created() {
		this.abouts();
	},
	methods: {
		async abouts() {
			const res = await this.$api.abouts();
			if (res.code == 1) {
				this.comInfo = res.data;
			}
		},
	}
}
</script>

<style lang="scss">
.cat_box {
	width: 295px;
	padding: 30px 15px 92px 18px;
	background-color: #f3f3f3;
	box-sizing: border-box;
	.cb_tit {
		border-bottom: 1px solid #dedede;
		padding-bottom: 10px;
		p {
			&:nth-child(1) {
				font-size: 30px;
			}
			&:nth-child(2) {
				font-size: 18px;
				color: #666;
				margin-top: 2px;
			}
		}
	}
	.cb_address {
		color: #7e7e7e;
		font-size: 16px;
		div {
			padding: 5px 0;
		}
	}
	.cb_more {
		color: #b20d0c;
		font-size: 16px;
		margin: 35px 0 30px 0;
	}
	.cb_ma {
		margin-top: 20px;
		img {
			width: 140px;
		}
	}
}
@media screen and (max-width: 1600px) {
	.cat_box {
		width: 280px;
	}
}
</style>